/** PO ids linked to prepayment rows (allocations or purchase_orders). */
export function purchaseOrderIdsFromPrepayment(prepayment) {
  const ids = new Set();
  const add = id => {
    const numeric = Number(id);
    if (numeric) ids.add(numeric);
  };

  for (const row of prepayment?.allocations ?? []) {
    add(row.purchase_order?.id ?? row.purchase_order_id);
  }
  for (const po of prepayment?.purchase_orders ?? []) {
    add(po?.id);
  }

  return ids;
}

export function purchaseOrderIdsFromPrepayments(prepayments = []) {
  const ids = new Set();
  for (const prep of prepayments) {
    purchaseOrderIdsFromPrepayment(prep).forEach(id => ids.add(id));
  }
  return [...ids];
}

export function purchaseOrderIdsFromAllocationRows(allocations = []) {
  return [
    ...new Set(
      allocations.map(row => Number(row.purchase_order_id)).filter(Boolean),
    ),
  ];
}

export function prepaymentPurchaseOrderInvalidationTags(_result, _error, arg) {
  const poIds = [
    ...new Set([
      ...purchaseOrderIdsFromAllocationRows(arg?.allocations),
      ...purchaseOrderIdsFromPrepayments(arg?.prepayments),
    ]),
  ];

  const tags = ["purchaseOrderList", "PrePayment"];
  for (const id of poIds) {
    tags.push({ type: "purchaseOrderDetail", id });
    tags.push({ type: "prepaymentByPurchaseOrder", id });
  }
  return tags;
}

export function prepaymentByPurchaseOrderTagsFromParams(params) {
  if (!params || typeof params !== "string") return ["PrePayment"];

  const purchaseOrderIds = new URLSearchParams(params).get("purchase_order_ids");
  if (!purchaseOrderIds) return ["PrePayment"];

  const tags = ["PrePayment"];
  for (const raw of purchaseOrderIds.split(",")) {
    const id = Number(raw.trim());
    if (id) tags.push({ type: "prepaymentByPurchaseOrder", id });
  }
  return tags.length > 1 ? tags : ["PrePayment"];
}
